// extracted by mini-css-extract-plugin
export default {"container":"EventAllDayToggle_container__fk1EY","label":"EventAllDayToggle_label__2m+Z1"};